<template>
  <b-nav-item-dropdown :menu-class="['bolt-app-switcher']" :no-caret="true" :right="true">
    <template #button-content>
      <slot name="header">
        <font-awesome-icon :icon="['fas', 'th']" />
      </slot>
    </template>
    <slot name="dropdown">
      <b-dropdown-item
        v-for="app in apps"
        :key="app.name"
        :class="currentApp.name === app.name ? 'current' : ''"
        :href="app.url"
        @click="(event) => goto(app, event)"
      >
        <img :alt="app.name" :src="`${iconHost}/icons/small/${app.name}.png`" :title="app.title" />
        <div>{{ app.title }}</div>
      </b-dropdown-item>
    </slot>
  </b-nav-item-dropdown>
</template>

<script>
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faTh);
Vue.component("FontAwesomeIcon", FontAwesomeIcon);

export default {
  name: "BoltAppSwitcher",

  props: {
    urls: {
      type: Object,
      default: () => ({
        "3cx": "https://tmrg.3cx.com.au:5001/webclient",
        bolt: "https://alpha.letsbolt.io",
        dash: "https://dash.alpha.letsbolt.io",
        mapit: "https://mapit.alpha.letsbolt.io",
        buzz: "https://buzz.alpha.letsbolt.io",
        prospectr: "https://prospectr.alpha.letsbolt.io",
        revuze: "https://revuze.alpha.letsbolt.io",
      }),
    },
    iconHost: {
      type: String,
      default: "https://assets.letsbolt.com.au",
    },
  },

  data() {
    return {
      hidden: true,

      availables: [
        { name: "bolt", title: "BOLT" },
        { name: "3cx", title: "3CX" },
        { name: "dash", title: "DASH" },
        { name: "mapit", title: "MAPit" },
        { name: "buzz", title: "BUZZ" },
        { name: "prospectr", title: "ProspectR" },
        { name: "revuze", title: "ReVuze" },
      ],
    };
  },

  computed: {
    apps() {
      return this.availables
        .map((app) => {
          return {
            ...app,
            ...{
              url: this.urls[app.name] ? this.urls[app.name] : null,
            },
          };
        })
        .filter((app) => app.url);
    },

    currentApp() {
      const current = this.apps.filter((app) => {
        const url = new URL(app.url);
        return window.location.host === url.host;
      });

      if (current && current.length === 1) {
        return current[0];
      }

      return {
        name: "unknown",
        title: "Unknown",
        url: "",
      };
    },
  },

  methods: {
    goto(app, event) {
      if (app.name && this.urls[app.name]) {
        event.preventDefault();

        window.open(this.urls[app.name]);
      }
    },
  },
};
</script>

<style>
.bolt-app-switcher.dropdown-menu-right {
  width: 182px;
  padding: 0;
}

.bolt-app-switcher li {
  display: inline-block;
  width: 50%;
  height: 75px;
  overflow: hidden;
  float: left;
}

.bolt-app-switcher li.current {
  background-color: #e0f4fe;
}

.bolt-app-switcher li .dropdown-item {
  width: 50%;
  height: 75px;
  min-width: 100%;
  padding: 6px 18px;
  overflow: hidden;
  text-align: center;
}

.bolt-app-switcher li img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: 40px;
}

.bolt-app-switcher .dropdown-item {
  display: block;
}
</style>
